import React from 'react';
import ReactDOM from 'react-dom/client';

import '@vectord/styles/main.css';
import '@vectord/components/main.css';
import '@vectord/icons/main.css';

import App from './App';
import supressCogoToastWarning from 'utils/supressCogoToastWarning';

supressCogoToastWarning();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
